export default function phpVersionsReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_PHP_VERSIONS_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_PHP_VERSIONS_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_PHP_VERSIONS_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}